var queryString = require('query-string');

var setQuery = require('url-set-query');

var assign = require('object-assign');

var ensureHeader = require('./lib/ensure-header.js'); // this is replaced in the browser


var request = require('./lib/request.js');

var mimeTypeJson = 'application/json';

var noop = function noop() {};

module.exports = xhrRequest;

function xhrRequest(url, opt, cb) {
  if (!url || typeof url !== 'string') {
    throw new TypeError('must specify a URL');
  }

  if (typeof opt === 'function') {
    cb = opt;
    opt = {};
  }

  if (cb && typeof cb !== 'function') {
    throw new TypeError('expected cb to be undefined or a function');
  }

  cb = cb || noop;
  opt = opt || {};
  var defaultResponse = opt.json ? 'json' : 'text';
  opt = assign({
    responseType: defaultResponse
  }, opt);
  var headers = opt.headers || {};
  var method = (opt.method || 'GET').toUpperCase();
  var query = opt.query;

  if (query) {
    if (typeof query !== 'string') {
      query = queryString.stringify(query);
    }

    url = setQuery(url, query);
  } // allow json response


  if (opt.responseType === 'json') {
    ensureHeader(headers, 'Accept', mimeTypeJson);
  } // if body content is json


  if (opt.json && method !== 'GET' && method !== 'HEAD') {
    ensureHeader(headers, 'Content-Type', mimeTypeJson);
    opt.body = JSON.stringify(opt.body);
  }

  opt.method = method;
  opt.url = url;
  opt.headers = headers;
  delete opt.query;
  delete opt.json;
  return request(opt, cb);
}